import type { WalkListItem } from './api';

const COLS: (keyof WalkListItem)[] = [
  'voter_reg_num', 'first_name', 'last_name', 'address', 'city', 'zip', 'party', 'age',
  'latest_contact_result', 'latest_support_level', 'petition_signed',
  'has_donated', 'has_volunteered', 'do_not_contact', 'has_voted',
];

// Column headers that differ from the WalkListItem key they are read from.
const HEADERS: Partial<Record<keyof WalkListItem, string>> = { has_voted: 'voted' };

function cell(v: unknown): string {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function walkListToCsv(items: WalkListItem[]): string {
  const lines = [COLS.map(c => HEADERS[c] ?? c).join(',')];
  for (const it of items) {
    // voted is always written (false for a voter the ballot file never mentioned)
    lines.push(COLS.map(c => cell(c === 'has_voted' ? !!it[c] : it[c])).join(','));
  }
  return lines.join('\n') + '\n';
}
